import { render, staticRenderFns } from "./CoreItemFour.vue?vue&type=template&id=ffbd08da&scoped=true&"
import script from "./CoreItemFour.vue?vue&type=script&lang=js&"
export * from "./CoreItemFour.vue?vue&type=script&lang=js&"
import style0 from "./CoreItemFour.vue?vue&type=style&index=0&id=ffbd08da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbd08da",
  null
  
)

export default component.exports